<template>
    <section class="soproni_small_area for_new_page" style="padding:0 0;">
        <image-slider-widget v-if="page.widgets && page.widgets[0] && page.widgets[0].type == 'ImageSliderWidget'" :widget="page.widgets[0]" ></image-slider-widget>
        <div class="container">
            <div class="row">
                <template v-for="(widget, index) in page.widgets" v-if="widget.type != 'ImageSliderWidget'">
                    <component :is="widget.type" :key="index" :widget="widget"></component>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'

import DiscountProductsWidget from '@pages/page/widgets/DiscountProductsWidget.vue'
import FullSizeImageWidget from '@pages/page/widgets/FullSizeImageWidget.vue'
import HtmlWidget from '@pages/page/widgets/HtmlWidget.vue'
import CardWidget from '@pages/page/widgets/CardWidget.vue'
import ImageSliderWidget from '@pages/page/widgets/ImageSliderWidget.vue'


export default{
    mixins:[Endpoints],
    components:{
        DiscountProductsWidget,
        HtmlWidget,
        CardWidget,
        FullSizeImageWidget,
        ImageSliderWidget
    },
    props:['type'],
    data:function () {
        return {
            page: {
                widgets: []
            },
        };
    },
    beforeRouteUpdate (to, from, next) {
        next();

        this.init();
    },
    created: function (){
        this.init();
    },
    methods: {
        init:function () {
            var self = this;
            if (this.type){
                this.connGetPageByType(this.type,function (r) {
                    self.page = r.data;
                })
            }else{
                this.connGetPageDetailed(this.$route.params.pageId,function (r) {
                    self.page = r.data;
                })
            }
        }
        // getComponentByName(name){
        //     if (name == 'CardWidget') return CardWidget;
        //     if (name == 'HtmlWidget') return HtmlWidget;
        //     if (name == 'CardWidget') return CardWidget;
        //     if (name == 'ImageSliderWidget') return ImageSliderWidget;
        // }
    }
}
</script>

<style>
.no-widget-padding{
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// CustomPage.vue?0d94b3d6